import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardService } from 'app/dashboard/dashboard.service';

@Injectable({
  providedIn: 'root'
})
export class CounselorService {

  constructor(public http: HttpClient, public dashboardService: DashboardService) { }


  getCounselorById(counselorId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Councelor/GetOpdCounselorExaminationByCounselorId/" + counselorId);
  }
  getpackageById(counselorId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Councelor/GetOpdCounselorPackageDetailByCounselorId/" + counselorId);
  }

  getSurgeryById(counselorId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Councelor/GetOpdCounselorSurgeryDetailByCounselorId/" + counselorId);
  }
  getTrackingdetails(counselorId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "councelor/GetOpdCounselorDateTrackingDetailByCounselorId/" + counselorId);
  }

  getCounsVisit(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Councelor/GetCounselorVisitListByRegID/" + regid);
  }
  getAnarType() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PopupMaster/getPop/2");
  }
  saveExamCounselor(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "Councelor/InsertOpdCounselorExamination", payload);
  }

  GetCounselorAdditionalService(CounselorId){
    return this.http.get<any>(this.dashboardService.newbaseUrl+"Councelor/GetCounselorAdditionalServiceDetailByCounselorId/" + CounselorId)
  }
}
